import { UpdateWorkflowRequest } from 'types';
import {
  UpdateWorkflowRequestAction,
  WORKFLOWS_ACTION_TYPES,
  WorkflowsActionTypes,
} from './workflows.types';

export const fetchWorkflowsRequest = (): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_REQUEST,
});

export const fetchWorkflowsSuccess = (
  workflows: any[]
): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_SUCCESS,
  payload: workflows,
});

export const fetchWorkflowsFailure = (error: string): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_FAILURE,
  payload: error,
});

export const getWorkflowByCampaignRequest = (
  campaignId: string
): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_REQUEST,
  payload: campaignId,
});

export const getWorkflowByCampaignSuccess = (
  workflow: any
): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_SUCCESS,
  payload: workflow,
});

export const getWorkflowByCampaignFailure = (
  error: string
): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_FAILURE,
  payload: error,
});

export const updateWorkflowRequest = (
  data: UpdateWorkflowRequest
): UpdateWorkflowRequestAction => ({
  type: WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_REQUEST,
  payload: data,
});

export const updateWorkflowSuccess = (workflow: any): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_SUCCESS,
  payload: workflow,
});

export const updateWorkflowFailure = (error: string): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_FAILURE,
  payload: error,
});

export const publishWorkflowRequest = (data: {
  campaignId: string;
  flow: {
    nodes: any[];
    edges: any[];
  };
}): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_REQUEST,
  payload: data,
});

export const publishWorkflowSuccess = (
  workflow: any
): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_SUCCESS,
  payload: workflow,
});

export const publishWorkflowFailure = (
  error: string
): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_FAILURE,
  payload: error,
});

export const clearWorkflowState = (): WorkflowsActionTypes => ({
  type: WORKFLOWS_ACTION_TYPES.CLEAR_WORKFLOW_STATE,
});
